import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-marquee",
  class WyattMarquee extends WYATTElement {
    constructor() {
      super();

      this.track = this.querySelector("[data-track]");
      this.item = this.querySelector('[data-item="original"]');
      this.toggle = this.querySelector("[data-marquee-toggle]");

      if (!this.track || !this.item) return;

      this.startX = 0;
      this.startY = 0;

      this.handleResize = this.handleResize.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);

      this.setup();

      window.addEventListener("resize", this.handleResize);

      this.addEventListener("touchstart", this.handleTouchStart, { passive: true });
      this.addEventListener("touchmove", this.handleTouchMove, { passive: false });

      if (this.toggle) {
        this.toggle.addEventListener("click", () => this.togglePause());
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      this.removeEventListener("touchstart", this.handleTouchStart);
      this.removeEventListener("touchmove", this.handleTouchMove);
    }

    setup() {
      this.removeClones();
      this.cloneItems();
      this.setTransform();
    }

    removeClones() {
      this.querySelectorAll('[data-item="cloned"]').forEach((node) => {
        node.remove();
      });
    }

    cloneItems() {
      const clone = this.item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.dataset.item = "cloned";
      this.track.appendChild(clone);
    }

    setTransform() {
      const originalWidth = this.item.getBoundingClientRect().width;

      if (!originalWidth) return;

      this.track.style.setProperty("--marquee-scroll-width", `-${originalWidth}px`);
    }

    handleResize() {
      this.setTransform();
    }

    handleTouchStart(event) {
      const touch = event.touches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
    }

    handleTouchMove(event) {
      const touch = event.touches[0];
      const deltaX = Math.abs(touch.clientX - this.startX);
      const deltaY = Math.abs(touch.clientY - this.startY);

      if (deltaX > deltaY) {
        event.preventDefault();
      }
    }

    togglePause() {
      const isPaused =
        getComputedStyle(this.track).animationPlayState === "paused";

      this.track.style.animationPlayState = isPaused ? "running" : "paused";

      if (this.toggle) {
        this.toggle.setAttribute("aria-pressed", String(!isPaused));

        const icon = this.toggle.querySelector("[data-icon]");
        if (icon) {
          icon.textContent = isPaused ? "⏸" : "▶";
        }

        this.toggle.setAttribute(
          "aria-label",
          isPaused ? "Pause scrolling content" : "Play scrolling content"
        );
      }
    }
  }
);